import { render } from "./StaticImage.vue?vue&type=template&id=365ed69e"
import script from "./StaticImage.vue?vue&type=script&lang=js"
export * from "./StaticImage.vue?vue&type=script&lang=js"

import exportComponent from "/OfficialWebsite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__